import {MdAccessTime} from 'react-icons/md';
import {cn} from '../../../../../../lib/classname';
import {
  getDaysFromToday,
  getTimeFromDate,
  isValidDate,
} from '../../../../../../shared/services/dateUtils';
import {formatDateWithTime} from '../../../../../../shared/services/formatDate';

type Props = {
  deadline?: string;
  hasResult: boolean;
};

const formattedDeadline = (deadline: string) =>
  `${formatDateWithTime(deadline)} 締切`;

/**
 * 締切日表示コンポーネント
 *
 * 赤文字表示条件: 締切日が3日以内 かつ 結果未入力
 *
 * 表示パターン:
 * - 3日後: 「3日後HH:MM締切」(赤文字)
 * - 2日後(明後日): 「明後日HH:MM締切」(赤文字)
 * - 1日後(明日): 「明日HH:MM締切」(赤文字)
 * - 0日後(本日): 「本日HH:MM締切」(赤文字)
 * - 過去(負の日数): 「締切超過」(赤文字)
 * - 4日後以降 または 結果入力済み: 「MM/DD HH:MM 締切」(通常色)
 */
export const DeadlineText: React.FC<Props> = ({deadline = '', hasResult}) => {
  if (!isValidDate(deadline)) return null;

  const deadlineFromToday = getDaysFromToday(deadline);
  const deadlineTime = getTimeFromDate(deadline);
  // 赤文字表示: 3日以内 かつ 結果未入力
  const isAttentionView = deadlineFromToday <= 3 && !hasResult;
  const deadlineText = isAttentionView
    ? deadlineFromToday === 3
      ? `3日後${deadlineTime}締切`
      : deadlineFromToday === 2
        ? `明後日${deadlineTime}締切`
        : deadlineFromToday === 1
          ? `明日${deadlineTime}締切`
          : deadlineFromToday === 0
            ? `本日${deadlineTime}締切`
            : '締切超過'
    : formattedDeadline(deadline);

  return (
    <div
      className={cn('flex items-center text-black-2 gap-4 text-sm', {
        'text-notification-1': isAttentionView,
      })}
    >
      <MdAccessTime size={12} />
      {deadlineText}
    </div>
  );
};
